import {createStyles} from '@material-ui/core/styles'
import {Colors} from 'components/common/useBaseStyle'

const ProductsOrderStyle = () =>
  createStyles({
    // globalReset: {
    //   '& *': {
    //     margin: 0,
    //     padding: 0,
    //     boxSizing: 'border-box',
    //   },
    // },

    // body: {
    //   fontFamily: "'Arial', sans-serif",
    //   background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    //   minHeight: '100vh',
    //   padding: '20px',
    //   display: 'flex',
    //   justifyContent: 'center',
    //   alignItems: 'center',
    // },
    tabsUnderline: {
      display: 'flex',
      borderBottom: '2px solid #e5e7eb',
      position: 'relative',
      marginBottom: 20,
    },
    tabUnderline: {
      padding: '16px',
      background: 'none',
      border: 'none',
      fontSize: '15px',
      fontWeight: 700,
      color: '#6b7280',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      position: 'relative',
      '&:hover': {
        color: '#374151',
      },
    },
    underlineIndicator: {
      position: 'absolute',
      bottom: '-2px',
      height: '3px',
      background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)',
      borderRadius: '2px 2px 0 0',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    },
    activeTabs: {
      color: '#0bc7c8 !important',
    },
    active: {
      height: '3px',
      borderRadius: '2px',
      backgroundColor: '#0bc7c8',
      marginBottom: '-2.5px',
    },
    notation: {
      display: 'inline-block',
      width: 6,
      height: '100%',
      minHeight: '1.125rem',
      marginRight: 9,
      backgroundColor: Colors.primary,
      paddingTop: 5,
      marginTop: 5,
    },
    tableContainer: {
      padding: '20px 10px',
    },
    table: {
      borderCollapse: 'collapse',
      width: '100%',
      '& th, & td': {
        border: '1px solid #ddd',
        padding: '8px',
      },
      '& th': {
        backgroundColor: '#f2f2f2',
      },
    },

    paymentContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      padding: '0',
      '@media (max-width: 1400px)': {
        padding: '0 0 0',
      },
    },
    containerProductOrderPayment: {
      borderRadius: '8px',
      padding: '26px 30px',
      background: '#fff',
    },
    boxProductOrderPayment: {},
    productOrderPayment: {
      display: 'flex',
      flexDirection: 'column',
    },
    productInformation: {
      padding: '20px',
      width: '100%',
      flex: 1,
    },
    buyerInformation: {
      flex: 1,
      padding: '20px',
    },
    card: {
      background: 'white',
      borderRadius: '15px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      padding: '25px',
      position: 'relative',
      overflow: 'hidden',
      transform: 'translateY(0)',
      transition: 'all 0.3s ease',

      '&::before': {
        content: "''",
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: 'linear-gradient(90deg, #0cc7c7, #00a8a8)',
      },

      // '&:hover': {
      //   transform: 'translateY(-5px)',
      //   boxShadow: '0 15px 40px rgba(0, 0, 0, 0.15)',
      // },
    },

    customerInfo: {
      flex: 1,
    },

    cardHeader: {
      display: 'flex',
      position: 'relative',
      padding: '20px 20px 0 20px',
    },

    cardNumber: {
      background: '#0cc7c7',
      color: 'white',
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      marginRight: '15px',
      fontSize: '14px',
    },

    cardTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#333',
      width: '100%',
      paddingBottom: '8px',
      borderBottom: '1px solid #d9d6d6',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 5,
    },
    line: {
      height: '1px',
      backgroundColor: '#d9d6d6',
      margin: '8px 0',
    },

    productSection: {
      padding: '10px 0',
      lineHeight: 1.6,
    },

    infoItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '12px',
    },

    bullet: {
      color: '#0cc7c7',
      fontWeight: 'bold',
      marginRight: '8px',
      fontSize: '16px',
      lineHeight: 1.5,
    },

    infoText: {
      color: '#333',
      fontSize: '18px',
    },

    infoPrice: {
      color: '#0cc7c7',
      fontSize: '18px',
    },

    priceHighlight: {
      color: '#0cc7c7',
      fontWeight: 'bold',
      fontSize: '16px',
    },

    dateHighlight: {
      color: '#0cc7c7',
      fontWeight: 'bold',
    },

    count: {
      color: '#666',
      fontWeight: 'normal',
    },

    subItems: {
      marginLeft: '20px',
      marginBottom: '15px',
    },

    subItem: {
      color: '#555',
      fontSize: '16px',
      paddingLeft: '10px',
    },

    productInfo: {
      flex: 1,
    },

    periodSection: {
      background: '#f8f9fa',
      padding: 15,
      borderRadius: 8,
      borderLeft: ' 3px solid #0cc7c7',
      height: 80,
      width: '100%',
      overflowY: 'auto',
    },

    periodSectionV2: {
      background: '#f8f9fa',
      padding: 15,
      borderRadius: 8,
      marginBottom: 30,
      borderLeft: ' 3px solid #0cc7c7',
      minHeight: 80,
      width: 'calc(100% - 40px)',
    },

    noticeSection: {
      background: 'linear-gradient(135deg, #e8f8f8, #d1f2f2)',
      borderLeft: '4px solid #0cc7c7',
      padding: '15px',
      borderRadius: '0 8px 8px 0',
    },

    noticeText: {
      color: '#0cc7c7',
      fontWeight: 'bold',
      fontSize: '16px',
    },

    contactInfo: {
      background: '#f8f9fa',
      borderRadius: '10px',
      padding: '15px',
      marginTop: '15px',
      marginBottom: '30px',
    },

    contactRow: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',

      '&:last-child': {
        marginBottom: 0,
      },
    },

    contactIcon: {
      width: '8px',
      height: '8px',
      background: '#0cc7c7',
      borderRadius: '50%',
      marginRight: '12px',
    },

    contactText: {
      color: '#555',
      fontSize: '16px',
      minWidth: '100px',
    },

    highlightText: {
      color: '#0cc7c7',
      fontWeight: 'bold',
    },

    infoRow: {
      '&:hover': {
        background: '#f8f9fa',
        borderRadius: '8px',
      },
    },

    // Media queries
    '@media (max-width: 768px)': {
      paymentContainer: {
        flexDirection: 'column',
      },

      card: {
        padding: '20px',
      },
    },

    paymentButtonContainer: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      gap: 50,
      '& button': {
        height: 60,
        minWidth: 200,
        fontSize: 24,
      },
    },

    btnWrap: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      marginTop: 20,
    },

    btnChildWrap: {
      width: '70%',
      maxWidth: 560,
    },

    buttonPayment: {
      height: 45,
      width: '100%',
      fontSize: 20,
      fontWeight: 'bold',
      marginTop: 20,
    },

    // Your existing styles
    listCard: {
      display: 'grid',
      gap: '25px',
      marginBottom: '20px',
      gridTemplateColumns: 'repeat(auto-fit, 420px)',
    },
    cardInfo: {
      minHeight: '400px',
      border: '1px solid #8f96a2',
      padding: '15px',
      width: '300px',
      position: 'relative',
      wordBreak: 'break-word',
      marginTop: '10px',
      marginBottom: '10px',
      borderRadius: '5px',
      boxShadow:
        '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    },
    productName: {
      fontWeight: 'bold',
      fontSize: '18px',
      marginBottom: '15px',
    },
    cardInfoAmount: {
      marginBottom: '15px',
    },
    noProduct: {
      textAlign: 'center',
      fontSize: '17px',
      fontWeight: 'bold',
    },
    cardInfoDuration: {
      marginTop: '15px',
    },
    cardInfoDesc: {
      marginBottom: '70px',
      wordBreak: 'break-word',
    },
    cardInfoBtns: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '10px',
      width: '100%',
      '& button': {
        flex: 1,
        height: '40px',
        fontSize: '14px',
        fontWeight: 'bold',
      },
    },
    cardInfoMY: {
      position: 'absolute',
      backgroundColor: '#4073c5',
      color: '#ffffff',
      padding: '12px',
      top: 0,
      right: 0,
    },
    paymentWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    cardWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      padding: 20,
      border: '1px solid #8f96a2',
      height: 'fit-content',

      '& li': {
        marginLeft: 20,
      },
    },
    characteristic: {
      display: 'flex',
      alignItems: 'center',
      gap: 5,
      marginLeft: 20,
    },
    characteristicTitle: {
      width: 85,
    },

    /* Page Header */
    pageHeader: {},

    pageTitle: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#333',

      margin: '20px 0',

      '& first-child': {
        marginTop: 0,
      },
    },

    titleIcon: {
      width: '8px',
      height: '8px',
      background: '#333',
      borderRadius: '2px',
      marginRight: '12px',
    },

    /* Product Grid */
    productsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
      gap: '25px',
      alignItems: 'start',
    },

    /* Product Card */
    productCard: {
      minWidth: '420px',
      width: '420px',
      maxWidth: '420px',
      height: '100%',
      background: 'white',
      border: '2px solid #e0e0e0',
      borderRadius: '12px',
      overflow: 'hidden',
      position: 'relative',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
      transition: 'all 0.3s ease',
      animation: 'fadeInUp 0.6s ease-out',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
        borderColor: '#0cc7c7',
      },
      '&::before': {
        content: "''",
        position: 'absolute',
        top: '-2px',
        left: '-2px',
        right: '-2px',
        bottom: '-2px',
        background: 'linear-gradient(45deg, #0cc7c7, #17a2b8, #0cc7c7)',
        borderRadius: '14px',
        zIndex: '-1',
        opacity: 0,
        transition: 'opacity 0.3s ease',
      },
      '&:hover::before': {
        opacity: 0.1,
      },
    },

    /* Badge Animation */
    myBadge: {
      position: 'absolute',
      top: 0,
      right: 0,
      background: 'linear-gradient(135deg, #4a90e2, #357abd)',
      color: 'white',
      padding: '8px 16px',
      fontSize: '12px',
      fontWeight: 'bold',
      borderRadius: '0 12px 0 12px',
      letterSpacing: '1px',
      boxShadow: '0 2px 8px rgba(74, 144, 226, 0.3)',
      animation: 'badgePulse 3s infinite',
    },

    /* Card Content */
    cardContent: {
      padding: '0 20px 40px',
      position: 'relative',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
    },

    productOrderPaymentTitle: {
      fontSize: '22px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '8px',
      padding: '8px 8px 8px 20px',
    },

    productTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '8px',
    },

    productType: {
      color: '#666',
      fontSize: '14px',
      marginBottom: '12px',
    },

    price: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#0cc7c7',
      marginBottom: '10px',
    },

    /* Specs */

    specItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 0',
      fontSize: '14px',
      color: '#555',
      borderBottom: '1px solid #f5f5f5',
      transition: 'all 0.3s ease',
      '&:hover': {
        background: 'linear-gradient(90deg, transparent, #f0fdfd, transparent)',
        paddingLeft: '10px',
        paddingRight: '10px',
        marginLeft: '-10px',
        marginRight: '-10px',
        borderRadius: '6px',
      },
    },

    specLabel: {
      fontWeight: 500,
    },

    clickableSpecLabel: {
      fontWeight: 500,
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },

    specValue: {
      color: '#0cc7c7',
      fontWeight: 'bold',
    },

    /* Action Buttons */
    actionButtons: {
      display: 'flex',
      gap: '12px',
      padding: '0 20px 20px 20px',
    },

    btn: {
      flex: 1,
      padding: '12px 16px',
      border: 'none',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: 'bold',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      position: 'relative',
      overflow: 'hidden',
      '&:active': {
        transform: 'translateY(0)',
      },
    },

    btnPrimary: {
      background: 'linear-gradient(135deg, #0cc7c7, #00a8a8)',
      color: 'white',
      boxShadow: '0 3px 10px rgba(12, 199, 199, 0.3)',
      '&:hover': {
        background: 'linear-gradient(135deg, #00a8a8, #008888)',
        transform: 'translateY(-2px)',
        boxShadow: '0 5px 15px rgba(12, 199, 199, 0.4)',
      },
    },

    btnSecondary: {
      background: 'linear-gradient(135deg, #17a2b8, #138496)',
      color: 'white',
      boxShadow: '0 3px 10px rgba(23, 162, 184, 0.3)',
      '&:hover': {
        background: 'linear-gradient(135deg, #138496, #117a8b)',
        transform: 'translateY(-2px)',
        boxShadow: '0 5px 15px rgba(23, 162, 184, 0.4)',
      },
    },

    btnSuccess: {
      background: 'linear-gradient(135deg, #28a745, #1e7e34)',
      color: 'white',
      boxShadow: '0 3px 10px rgba(40, 167, 69, 0.3)',
      '&:hover': {
        background: 'linear-gradient(135deg, #1e7e34, #155724)',
        transform: 'translateY(-2px)',
        boxShadow: '0 5px 15px rgba(40, 167, 69, 0.4)',
      },
    },

    /* Animations */
    '@keyframes fadeInUp': {
      from: {
        opacity: 0,
        transform: 'translateY(30px)',
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },

    '@keyframes badgePulse': {
      '0%, 100%': {
        boxShadow: '0 2px 8px rgba(74, 144, 226, 0.3)',
      },
      '50%': {
        boxShadow: '0 4px 16px rgba(74, 144, 226, 0.5)',
      },
    },
    periodText: {
      fontSize: 14,
      color: '#333',
      lineHeight: 1.6,
      marginBottom: 5,
    },
    periodHighlight: {
      color: '#0cc7c7',
      fontWeight: 'bold',
    },
    description: {
      wordBreak: 'break-word',
    },
    noProductsContainer: {
      background: '#fafafa',
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      padding: '40px 40px',
      textAlign: 'center',
    },
    noProductsIcon: {
      fontSize: '48px',
      marginBottom: '20px',
      opacity: 0.6,
    },
    noProductsTitle: {
      fontSize: '18px',
      color: '#666',
      marginBottom: '10px',
      fontWeight: 500,
    },
    noProductsSubtitle: {
      fontSize: '14px',
      color: '#999',
      marginBottom: '25px',
      lineHeight: 1.5,
    },
    informationInput: {
      height: 40,
      width: '90%',
      border: '1px solid #dcdcdc',
      paddingLeft: 10,
    },
    productIcon: {
      width: 16,
      height: 16,
      background: '#0cc7c7',
    },
    clickableText: {
      '&:hover': {
        cursor: 'pointer',
        textDecoration: 'underline',
      },
    },
  })

export default ProductsOrderStyle
